import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { fetchAllTypeaheadDeviceManufacturers } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class DeviceManufacturerTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadDeviceManufacturers: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadDeviceManufacturers(DeviceManufacturerTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        let options = [];
        if (this.props.suggestions.length) {
            options = this.props.suggestions.map(manufacturer => ({
                label: manufacturer.name, value: manufacturer.id
            }));
        }

        return (
            <MultiTypeahead
                options={options || []}
                isMulti
                isLoading={this.state.isLoading}
                value={this.props.value}
                titleId="deviceManufacturer"
                animatedPlaceholder={this.props.animatedPlaceholder}
                onChangeSuggestion={this.props.onChangeSuggestion}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === DeviceManufacturerTypeahead.name
            ? typeahead.list
            : DeviceManufacturerTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadDeviceManufacturers,
})(DeviceManufacturerTypeahead);
